export default "__VITE_ASSET__EYm0BxDm__"